import repository from 'client/repository';
import alertActions from 'areas/alert/actions';
import configConstants from '../constants'
import { updatePollFrequency } from 'workers/mediator';

const appConfigSuccess = (config) => { return { ...config, type: configConstants.APP_CONFIG_SUCCESS } };

const loadStarted = () => { return { type: configConstants.CONFIG_LOAD_STARTED }; }

const loadEnded = () => { return { type: configConstants.CONFIG_LOAD_ENDED }; }

export default {

    denyReasonsLoaded: (response) => {
        return { ...response, type: configConstants.DENY_REASONS_SUCCESS }
    },

    getAppConfig: () => {
        return async dispatch => {
            try {

                dispatch(loadStarted());

                // query the server for the configuration
                const config = await repository.config.getServerConfig();

                // dispatch this state change
                dispatch(appConfigSuccess(config));

                updatePollFrequency(config.clientCacheDurationMinutes);

                dispatch(loadEnded());
            } catch (e) {
                dispatch(alertActions.error(e.toString()));
                dispatch(loadEnded());
            }
        }
    }
};
